import * as R from 'ramda';
import * as Dfns from 'date-fns/fp';

export interface DateCount {
  date: string;
  count: number;
}

export const EXPAND_LABELS = {
  dayPart: 'Expand Dayparts',
  network: 'Expand Networks',
  length: 'Expand Lengths'
};
export const EXPAND_KEYS = ['dayPart', 'network', 'length'] as const;
export type ExpandByKey = (typeof EXPAND_KEYS)[number] | 'spots';
export type ExpandByMap = Partial<Record<ExpandByKey, boolean>>;
export const TableMetric = {
  SPEND: 'Estimated Spend',
  SPOTS: 'Spots'
} as const;
export const TABLE_METRIC_OPTIONS = Object.values(TableMetric);

export const ALL_LENGTHS = 'All Lengths';
export const ALL_NETWORKS = 'All Networks';

export const TABLE_LEFT_WIDTH = 150;
export const TABLE_TOP_HEIGHT = 64;
export const TABLE_ROW_HEIGHT = 32;
export const TABLE_MIN_COLUMN_WIDTH = 100;
// StickyTable reserves this for its scrollbars; columns fit inside it so neither appears needlessly.
export const TABLE_SCROLLBAR_SIZE = 8;

const DATE_FORMAT = 'yyyy-MM-dd';

export const DEFAULT_DATE = R.pipe(
  Dfns.startOfISOWeek,
  Dfns.subWeeks(1),
  Dfns.format(DATE_FORMAT)
)(new Date());

export const CUTOFF_DATE = R.pipe(Dfns.startOfISOWeek, Dfns.format(DATE_FORMAT))(new Date());

export const streamingDate = R.pipe(
  Dfns.startOfISOWeek,
  Dfns.addDays(1),
  Dfns.subWeeks(1)
)(new Date());

// A column header loses `network` or `length` when that dimension is collapsed.
export interface ColHeader {
  network?: string;
  length?: number;
}
export type TopHeader = ColHeader | typeof ALL_NETWORKS;
